/* eslint-disable array-callback-return */
import * as React from 'react';
import { FC } from 'react';
import { AppContext } from '../../Context/app-state';
import Data, { TToy } from '../../Data/data';
import './Choose-Toys.css';

interface IProps {
  options: TToy;
}

const ChosenToy: FC<IProps> = ({ options }) => {
  const { toysOnTree } = React.useContext(AppContext);
  const [toysInBox, setToysInBox] = React.useState<string[]>([]);
  const { num, count } = options;
  React.useEffect(() => {
    setToysInBox(
      new Array(+count)
        .fill('')
        .map((_, idx) => {
          return toysOnTree.some((el) => el.id === num && +el.index === idx)
            ? ''
            : idx.toString();
        })
        .filter((el) => el !== ''),
    );
  }, [count, toysOnTree, num]);
  const dragStart = (e: React.DragEvent<HTMLImageElement>) => {
    const { id, dataset } = e.target as HTMLElement;
    e.dataTransfer.setData('data', JSON.stringify({ id, dataset }));
  };
  return (
    <div className="chosens-toy" key={num}>
      <p className="chosens-toy__count">
        <span>{toysInBox.length}</span>{' '}
      </p>
      {toysInBox.map((el) => {
        return (
          <img
            id={num}
            key={num + el}
            data-index={el}
            onDragStart={dragStart}
            draggable
            className="chosens-toy__image"
            src={`./assets/toys/${num}.png`}
            alt="toy"
          />
        );
      })}
    </div>
  );
};

export default function ChooseToys() {
  const { chosens } = React.useContext(AppContext);
  const displayToys = () => {
    let res: TToy[] = [];
    if (chosens.length === 0) {
      res = Data.slice(0, 20);
    } else {
      res = Data.filter((el) => chosens.includes(el.num));
    }
    return res.map((el) => {
      return <ChosenToy options={el} />;
    });
  };

  return <div className="App-tree__chosens-toys">{displayToys()}</div>;
}
